import {Tag} from '@/profile-creation-wizard/components/for-creation/Tag';
import {
    Address,
    ExperienceLevel,
    FunctionalSkill,
    Language,
    ProfileCreationForm,
    WorkplacePreference,
} from '@/profile-creation-wizard/components/for-creation/store';
import {ProfileCreationFunnelMode} from '@/profile-creation-wizard/config/steps/ProfileCreationSteps';

export interface HostConfiguration {
    priceConfig: PriceConfiguration;
}
interface PriceConfiguration {
    maxPriceAllowed: number;
    minPriceAllowed: number;
}

export class CreationFormValidation {
    isHeadlineValid(headline: string | null): boolean {
        if (!headline) {
            return false;
        }
        const length = headline.trim().length;

        return length >= 5 && length <= 50;
    }

    isLocationValid(address: Address): boolean {
        if (!address) {
            return false;
        }

        if (!address.countryCode || !address.city || !address.lat || !address.lon) {
            return false;
        }

        if (!address.formattedAddress || address.formattedAddress.length > 100) {
            return false;
        }

        return true;
    }

    isWorkplacePreferenceValid(workplacePreference: WorkplacePreference | null): boolean {
        return !!workplacePreference;
    }

    isExperienceLevelValid(experienceLevel: ExperienceLevel | null): boolean {
        return !!experienceLevel;
    }

    isFunctionalSkillsValid(functionalSkills: FunctionalSkill[]): boolean {
        return functionalSkills.length >= 4;
    }

    isTagsValid(tags: Tag[]): boolean {
        return tags.length >= 4;
    }

    isPriceValid(price: number, priceConfig: PriceConfiguration): boolean {
        return price >= priceConfig.minPriceAllowed && price <= priceConfig.maxPriceAllowed;
    }

    private hasLanguage(languages: Language[]): boolean {
        return languages.length > 0;
    }

    isValid(form: ProfileCreationForm, hostConfiguration: HostConfiguration, funnelMode: string): boolean {
        const isStrategyFunnelMode = funnelMode == ProfileCreationFunnelMode.STRATEGY;
        return (
            form.familiesCategoriesEdition.hasCompleteSelection() &&
            this.isHeadlineValid(form.headline) &&
            this.isLocationValid(form.address) &&
            this.isExperienceLevelValid(form.experienceLevel) &&
            (this.isTagsValid(form.tags) || isStrategyFunnelMode) &&
            this.isPriceValid(form.price, hostConfiguration.priceConfig) &&
            this.hasLanguage(form.languages)
        );
    }
}
